import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../../shared/services/http-request.service';
import { ApiUrlConstants } from '../../../shared/constants/api_url_constants';
import { Observable, forkJoin } from 'rxjs';
import { ApiResponse } from 'src/app/all-modules/shared/common-model/common.model';
import { clientAddDTO, clientAddressViewModel, clientDetailsForSO, clientListForSO, clientTeamViewModel, clientUpdateDTO, clientViewModelForDetails, clientViewModelForDropdownList, clientViewModelForList, soListForClientTeamAllocationChangeViewModel } from '../../models/client-management/client-model';
import { accountExeManagerAndCoordinatorViewModel } from '../../models/user-management/user_models';
import { rateCardShortViewModel } from '../../models/client-rate-card/client-rate-card.model';
import { clientShortViewModel } from '../../models/platinum-instruction-template/platinum-instruction-template.model';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private httpRequestService: HttpRequestService) { }

  getAllClientsForList(): Observable<clientViewModelForList[]> {
    return this.httpRequestService.getData<clientViewModelForList[]>(ApiUrlConstants.clientGetAll);
  }
  getClientById(id: any): Observable<clientViewModelForDetails> {
    return this.httpRequestService.getData<clientViewModelForDetails>(`${ApiUrlConstants.clientGetById}${id}`);
  }
  addClient(data: clientAddDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.clientAdd, data);
  }
  updateClient(data: clientUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.clientUpdate, data);
  }
 
  getAllRateCardActiveAccountExMgrAndCoordinator(): Observable<any[]> {
    const getAllAccountExMgrCoordinators = this.httpRequestService.getData<accountExeManagerAndCoordinatorViewModel[]>(ApiUrlConstants.userGetAllActiveAccountExMgrAndCoordinator);
    const getAllRateCards = this.httpRequestService.getData<rateCardShortViewModel[]>(ApiUrlConstants.rateCardGetAllActive);
    return forkJoin([getAllAccountExMgrCoordinators, getAllRateCards]);
  }
  getAllActiveAccountExMgrAndCoordinator(): Observable<accountExeManagerAndCoordinatorViewModel[]> {
    return this.httpRequestService.getData<accountExeManagerAndCoordinatorViewModel[]>(ApiUrlConstants.userGetAllActiveAccountExMgrAndCoordinator);
  }
  getClientTeamByClientShowId(data: any): Observable<clientTeamViewModel> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.clientGetTeamByClientShowId, data);
  }
  getAllForSOByClientType(clientType: any): Observable<clientListForSO[]> {
    return this.httpRequestService.getData<clientListForSO[]>(`${ApiUrlConstants.clientGetAllByClientTypeForSO}${clientType}`);
  }
  getClientDetailsForSOByClientShowId(data: any): Observable<clientDetailsForSO> {
    return this.httpRequestService.postData<clientDetailsForSO>(ApiUrlConstants.clientGetDetailsForSOByClientShowId, data);
  }
  getAllClientForDropdown(): Observable<clientViewModelForDropdownList[]> {
    return this.httpRequestService.getData<clientViewModelForDropdownList[]>(ApiUrlConstants.clientGetAllForDropdown);
  }
  getAllExhibitorClientForDropdown(): Observable<clientViewModelForDropdownList[]> {
    return this.httpRequestService.getData<clientViewModelForDropdownList[]>(ApiUrlConstants.clientGetAllExhibitorForDropdown);
  }
  getAllSoListForClientTeamAllocation(id:string): Observable<soListForClientTeamAllocationChangeViewModel[]> {
    return this.httpRequestService.getData<soListForClientTeamAllocationChangeViewModel[]>(`${ApiUrlConstants.clientSoListForTeamAllocation}${id}`);
  }
  getClientAddressesByClientId(id: any): Observable<clientAddressViewModel[]> {
    return this.httpRequestService.getData<clientAddressViewModel[]>(`${ApiUrlConstants.clientAddressesGetById}${id}`);
  }
  getAllClientByAccountType(type: any): Observable<clientShortViewModel[]> {
    return this.httpRequestService.getData<clientShortViewModel[]>(`${ApiUrlConstants.clientGetAllByAccountType}${type}`);
  }
}
